import { createUrl, restGet } from '~/src/dash/api/rest';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

interface IAdvertiserOptionsResponse {
  Advertisers: ISelectOption[];
}

export async function fetchAdvertiserOptions(
  publisherID: string,
): Promise<IAdvertiserOptionsResponse> {
  const reqUrl = createUrl('/advertiser_options', publisherID, 'v1');
  const response = await restGet<IAdvertiserOptionsResponse>(reqUrl, {});
  return response.parsedBody as IAdvertiserOptionsResponse;
}

// this wrapper allows it to be used in the current format
export const generateAdvertiserOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  return fetchAdvertiserOptions(session.publisher.ID)
    .then(({ Advertisers }) => {
      if (checkUserInfoMasked(user.user)) {
        return Advertisers.map((advertiser) => ({
          ...advertiser,
          label: `demo_advertiser_${advertiser.id}`,
        }));
      }
      return Advertisers;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};

interface IOrderOptionsResponse {
  Orders: ISelectOption[];
}

export async function fetchOrderOptions(publisherID: string): Promise<IOrderOptionsResponse> {
  const reqUrl = createUrl('/order_options', publisherID, 'v1');
  const response = await restGet<IOrderOptionsResponse>(reqUrl, {});
  return response.parsedBody as IOrderOptionsResponse;
}

// this wrapper allows it to be used in the current format
export const generateOrderOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  return fetchOrderOptions(session.publisher.ID)
    .then(({ Orders }) => {
      if (checkUserInfoMasked(user.user)) {
        return Orders.map((order) => ({
          ...order,
          label: `demo_order_${order.id}`,
        }));
      }
      return Orders;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};

interface ITraffickerOptionsResponse {
  Traffickers: ISelectOption[];
}

export async function fetchTraffickerOptions(
  publisherID: string,
): Promise<ITraffickerOptionsResponse> {
  const reqUrl = createUrl('/trafficker_options', publisherID, 'v1');
  const response = await restGet<ITraffickerOptionsResponse>(reqUrl, {});
  return response.parsedBody as ITraffickerOptionsResponse;
}

// this wrapper allows it to be used in the current format
export const generateTraffickerOptionsList = (
  session: ISessionState,
  user: IUserState,
): Promise<ISelectOption[]> => {
  return fetchTraffickerOptions(session.publisher.ID)
    .then(({ Traffickers }) => {
      if (checkUserInfoMasked(user.user)) {
        return Traffickers.map((trafficker) => ({
          ...trafficker,
          label: `demo_trafficker_${trafficker.id}`,
        }));
      }
      return Traffickers;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
};
